<template>

  <v-app>

    <Screensaver v-if="items.length === 0" />
    <Login v-if="!logged" />
    <v-main v-else>



      <v-dialog persistent :value="!isOpenCashier" width="550">
        <DialogCashier v-if="!isOpenCashier" />
      </v-dialog>

      <v-dialog v-model="dialogOrder" overlay-color="black" width="550">
        <DialogOrder v-if="dialogOrder" @close-dialog="dialogOrder = false" />
      </v-dialog>

      <v-dialog overlay-color="black" v-model="preOrderDialog" width="550">
        <DialogPreOrder @submit="savePreOrder" />
      </v-dialog>

      <v-dialog overlay-color="black" v-model="dialogCheckPrice" width="550">
        <DialogCheckPrice v-if="dialogCheckPrice" @close-dialog="dialogCheckPrice = false" />
      </v-dialog>

      <v-dialog :close-delay="2" overlay-color="black" overlay-opacity="0.6" width="550" v-model="confirm"
        @keydown.enter="confirmProceed" @keydown.escape="confirm = false">
        <v-card class="pa-0" elevation="4" rounded="lg">
          <v-toolbar color="grey darken-4" flat>
            <v-icon color="red" size="36" class="mr-3">mdi-alert-circle</v-icon>
            <v-toolbar-title class="text-h4 font-weight-medium red--text">Atenção</v-toolbar-title>
          </v-toolbar>

          <v-card-text class="text-center text-h5 py-4">
            Tem certeza que deseja continuar?
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog overlay-color="black" v-model="dialogConference" width="550">
        <DialogConference v-if="dialogConference" @close-dialog="dialogConference = false"></DialogConference>
      </v-dialog>

      <v-dialog overlay-color="black" v-model="dialogCPF" width="550">
        <DialogCPF v-if="dialogCPF" @close-dialog="dialogCPF = false"></DialogCPF>
      </v-dialog>

      <v-dialog overlay-color="black" v-model="dialogPhone" width="550">
        <DialogPhone v-if="dialogPhone" @close-dialog="dialogPhone = false"></DialogPhone>
      </v-dialog>



      <v-dialog overlay-color="black" v-model="dialogSupply" width="550">
        <DialogSupply v-if="dialogSupply" @close-dialog="dialogSupply = false"></DialogSupply>
      </v-dialog>

      <v-dialog overlay-color="black" v-model="dialogWithdrawal" width="550">
        <DialogWithdrawal v-if="dialogWithdrawal" @close-dialog="dialogWithdrawal = false"></DialogWithdrawal>
      </v-dialog>


      <v-dialog overlay-color="black" v-model="dialogSummary" width="550">
        <DialogSummary v-if="dialogSummary" @close-dialog="dialogSummary = false"></DialogSummary>
      </v-dialog>

      <v-dialog overlay-color="black" v-model="dialogCalculator" width="550">
        <DialogCalculator v-if="dialogCalculator" @close-dialog="dialogCalculator = false">
        </DialogCalculator>
      </v-dialog>






      <v-dialog @keydown.enter="dialogProductError = false" @keydown.escape="dialogProductError = false"
        v-model="dialogProductError" max-width="500">
        <v-card color="error" class="pa-4" rounded="lg" elevation="6">
          <v-card-title class="white--text text-h6 font-weight-bold">
            <v-icon color="white" left class="mr-2">mdi-alert-circle</v-icon>
            Falha na leitura do código de barras
          </v-card-title>

          <v-card-text class="white--text text-body-2 mt-2">
            <div class="mb-4">
              Não conseguimos identificar o seguinte código:
              <v-chip class="ml-2" color="grey darken-3" dark small>{{ lastEan }}</v-chip>
            </div>

            <div class="mb-4">
              Verifique se o código está visível, bem posicionado e sem danos.
              <br />
              Se preferir, digite o código manualmente no sistema.
            </div>

            <v-divider class="my-4"></v-divider>

            <div v-if="lastItem.name" class="d-flex align-center">
              <v-icon color="white" left class="mr-2">mdi-check-circle</v-icon>
              <span class="text-subtitle-2 font-weight-medium mr-2">
                Último item registrado:
              </span>
              <v-chip color="green darken-2" text-color="white" small>{{ lastItem.name }}</v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>




      <v-dialog width="500" v-model="dialogFavorites">
        <v-card>
          <v-sheet max-height="640" class="overflow-auto">
            <v-list>
              <v-list-item-group>
                <v-list-item v-for="(favorite, index) in favorites.data" :key="index"
                  @click="searchProduct(favorite.ean[0])">
                  <v-list-item-content>
                    <v-list-item-title class="text-truncate">{{ favorite.name
                      }}</v-list-item-title>
                    <v-list-item-subtitle class="text-truncate">
                      {{ favorite.price | currency }} - Qtd: {{ getProductQuantity(favorite.id) > 0 ?
                        getProductQuantity(favorite.id) : '0' }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-sheet>
        </v-card>
      </v-dialog>



      <v-dialog transition="dialog-bottom-transition" @keydown.escape="cancelStone()" @keydown.enter="checkPaymentStatus()" overlay-color="black"
        overlay-opacity="0.95" :value="chargeStoneId" persistent width="300">

       
       
        <v-img src="/STONE_S920_mockup_2021.png" width="300" >

          <template v-slot:default>
    <v-row
  class="fill-height ma-0"
  align="center"
  justify="center"
>
  <div class="d-flex flex-column align-center">
    
    <span class="text-subtitle-2 grey--text text--darken-2 mb-4"> 
      MIX DA VILA
    </span>
    
    <v-progress-circular
      indeterminate
      size="40" color="grey darken-3"
      class="mb-3" ></v-progress-circular>

    <span class="body-1 font-weight-regular grey--text text--darken-4">
      Aguardando pagamento
    </span> 
    
    <span class="text-h6 font-weight-bold grey--text text--darken-4 mt-1">
      {{ paymentStone.amount | currency }}
    </span>
    
    <span class="text-caption grey--text mt-2">
      Método: {{ paymentStone.name }}
    </span>
    
  </div>
  
</v-row>
      </template>
        </v-img>

        



       
      </v-dialog>

      <v-dialog overlay-opacity="0.9" v-model="dialogPayment" @keydown.escape="amount = 0" width="500">
        <v-card v-if="dialogPayment" color="grey darken-3" class="text-center">
          <MoneyInput class="pa-5" v-model="amount" @keydown.enter="LaunchAmount(amount)" />
          <v-card-actions v-if="$vuetify.breakpoint.xs">
            <v-btn @click="LaunchAmount(amount)" block color="success">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent overlay-opacity="0.9" v-model="dialogMultiplier" width="210">
        <v-card v-if="dialogMultiplier" color="grey darken-3" class="text-center">
          <Input type="tel" icon="mdi-expand-all" class="pa-5" v-model="multiplier"
            @keydown.enter="confirmMultiplier()" />
          <v-card-actions v-if="$vuetify.breakpoint.xs">
            <v-btn @click="confirmMultiplier()" block color="success">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-bottom-sheet persistent :value="received.amount > 0 && !dialogPayment">
        <v-card color="info" class="pa-6 d-flex flex-column align-center">
          <v-card-title class="text-center d-flex flex-column align-center">
            <v-icon left size="72" class="mb-2">mdi-cash-register</v-icon>
            <span class="text-h4 font-weight-bold mb-1">Valor informado</span>
            <span class="text-h3 font-weight-bold">{{ received.amount | currency }}</span>
          </v-card-title>
          <v-card-text class="text-center py-4 d-flex flex-column align-center">

            <span class="text-h5 font-weight-bold mb-2">
              Selecione a forma de pagamento para continuar
            </span>
          </v-card-text>
          <v-divider class="my-2"></v-divider>

        </v-card>
      </v-bottom-sheet>


      <!-- Bottom Sheet para "Falta receber" controlado por  -->
      <v-bottom-sheet :value="receivable > 0 && totalReceived > 0" height="400px">
        <v-card light color="alert" class=" pa-6 d-flex justify-center align-center">
          <v-card-title class="text-center">
            <v-icon left size="72" class="mr-4">mdi-alert-circle</v-icon>
            <span class="text-h5 font-weight-bold">Falta receber: {{ receivable | currency }}</span>
          </v-card-title>
        </v-card>
      </v-bottom-sheet>



      <!-- Bottom Sheet para "Troco" controlado por change -->
      <v-bottom-sheet persistent v-model="dialogChange">
        <v-card v-if="dialogChange" light color="green" class="pa-6 d-flex justify-center align-center">
          <v-card-title class="text-center">
            <v-icon left size="72" class="mr-4">mdi-hand-extended</v-icon>
            <span class="text-h3 font-weight-bold">Troco: {{ lastOrder.change | currency }}</span>
          </v-card-title>
        </v-card>
      </v-bottom-sheet>

      <v-overlay :value="processing">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-dialog overlay-color="black" width="550" v-model="dialogsearchProduct">
        <v-list v-if="dialogsearchProduct">
          <v-list-item>
            <Input v-model="barcode" @keydown.enter="searchProduct(barcode)" />
          </v-list-item>
        </v-list>
      </v-dialog>





      




      <v-system-bar v-if="!stonePay" color="error" fixed lights-out height="30">

        <v-spacer></v-spacer>


        <v-icon>mdi-gesture-tap-button</v-icon>
        Modo POS Manual está ativo



        <v-spacer></v-spacer>

      </v-system-bar>

      <v-container v-if="$vuetify.breakpoint.xs" fluid class="pa-0">

        <v-app-bar app dense color="primary" light elevation="2">
          <v-toolbar-title class="text-subtitle-1 font-weight-bold">
            Total: {{ total | currency }}
          </v-toolbar-title>

          <v-spacer />


          <v-chip @click="openDialogMultiplier()" dark class="elevation-0">
            Quantidade
          </v-chip>
          <v-spacer />
          <v-chip @click="openPaymentDialog()" dark class="elevation-0">
            Valor
          </v-chip>
        </v-app-bar>




        <v-list dense v-if="items.length" class="py-0">
          <v-list-item-group>
            <v-list-item v-for="(item, index) in items.slice().reverse()" :key="`product-${index}`" class="py-1">
              <v-list-item-content>
                <v-list-item-title class="text-body-2 font-weight-medium">{{ item.name }}</v-list-item-title>
                <v-list-item-subtitle class="text-caption">
                  {{ item.unit === "kg" ? Number(item.quantity).toFixed(3) : item.quantity }} {{ item.unit }}
                  <span class="ml-2 grey--text text--darken-1">x {{ item.unit_price | currency }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action class="d-flex flex-row align-center">
                <span class="text-body-2 font-weight-bold mr-2">{{ (item.unit_price * item.quantity) | currency
                }}</span>
                <v-btn icon color="error" @click="removeProductFromCartList(index)" aria-label="Remover item">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
          <v-divider class="my-1" />
        </v-list>

        <v-bottom-navigation light app grow color="primary" class="elevation-2">
          <v-btn small @click="payWithMethod(1)" class="text-caption" color="success">
            <span>Dinheiro</span>
            <v-icon small>mdi-cash</v-icon>
          </v-btn>
          <v-btn small @click="payWithMethod(2)" class="text-caption" color="info">
            <span>Débito</span>
            <v-icon small>mdi-credit-card</v-icon>
          </v-btn>
          <v-btn small @click="payWithMethod(3)" class="text-caption" color="warning">
            <span>Crédito</span>
            <v-icon small>mdi-credit-card-outline</v-icon>
          </v-btn>
          <v-btn small @click="payWithMethod(7)" class="text-caption" color="primary">
            <span>Pix</span>
            <v-icon small>mdi-qrcode</v-icon>
          </v-btn>
        </v-bottom-navigation>
      </v-container>



      <v-container v-else fluid class="fill-height">



        <v-row shaped v-if="items.length !== 0 || isReceivePaymentActive">

          <v-col cols="12" sm="12">
            <v-card shaped>
              <v-card-text class="d-flex align-center justify-space-between">
                <v-img ref="logo" class="ma-2" src="/mixdavilawithoutshield.svg" alt="Logo sem fundo" contain
                  max-width="220"></v-img>
                <h2 class="font-weight-bold text-center"
                  style="font-size: 10vw; line-height: 1; padding: 0; white-space: nowrap; overflow: hidden; display: block; width: auto; color: #fbc02d;">
                  <span>{{ total | currency }}</span>
                </h2>
              </v-card-text>
            </v-card>


          </v-col>

        </v-row>

        <v-row v-if="items.length === 0 && !isReceivePaymentActive" align="center" justify="center">
          <v-col cols="12" class="d-flex justify-center align-center" style="min-height: 40vh;">
            <v-img class="animate-icon" src="/logo_no_background.svg" alt="Logo sem fundo" contain
              :max-width="$vuetify.breakpoint.xs ? 220 : $vuetify.breakpoint.sm ? 350 : 700"
              :max-height="$vuetify.breakpoint.xs ? 220 : $vuetify.breakpoint.sm ? 350 : 700" width="100%" height="auto"
              style="max-width: 90vw;"></v-img>
          </v-col>
        </v-row>

        <v-btn color="info" v-if="customer && customer.id !== 1" right fixed bottom fab large
          x-large><v-icon>mdi-invoice-text-check</v-icon></v-btn>















        <v-btn v-if="hasFrozenSale" color="info" left fixed bottom fab large x-large>
          <v-badge :content="frozenItems.length" color="red" overlap>
            <v-icon x-large>mdi-snowflake</v-icon>
          </v-badge>

        </v-btn>









        <v-row v-if="items.length !== 0 || isReceivePaymentActive">
          <v-col cols="12" md="3" class="d-none d-md-block">
            <v-card height="645" class="d-flex flex-column">
              <v-sheet max-height="640" class="flex-grow-1">
                <v-card-title>
                  <v-icon left>mdi-account</v-icon>
                  {{ customer.name || customer.document || 'Não disponível' }}
                  <v-spacer></v-spacer>
                </v-card-title>




                <v-divider></v-divider>



                <v-list>

                  <v-list-item v-for="(payment, index) in payments" tabindex="0" :ref="'payment-' + index"
                    :key="`payment-${index}`" @keydown.enter="removePaymentFromList(index)">
                    <v-list-item-content>
                      <v-list-item-title>
                        Pagamento em {{ payment.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle>{{ payment.amount | currency }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

              </v-sheet>




            </v-card>

          </v-col>


          <v-col cols="12" sm="9">
            <v-card height="645" class="mx-auto d-flex flex-column">
              <v-sheet max-height="640" class="overflow-auto flex-grow-1">
                <v-list>

                  <v-list-item v-for="(item, index) in items.slice().reverse()" :key="`product-${index}`"
                    class="d-flex align-center" tabindex="0" :ref="'product-' + index"
                    @keydown.enter="removeProductFromCartList(index)">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">{{ item.name }}</v-list-item-title>
                      <v-list-item-subtitle>
                        <span>{{ item.unit === "kg" ? item.quantity.toFixed(3) : item.quantity }} {{ item.unit
                          }}</span>
                        <span class="ml-2 text-secondary">X {{ item.unit_price | currency }}</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-list-item-action-text class="subtitle-1 font-weight-bold">{{ (item.unit_price *
                        item.quantity)
                        |
                        currency }}</v-list-item-action-text>
                    </v-list-item-action>

                  </v-list-item>
                </v-list>
              </v-sheet>

            </v-card>

          </v-col>
        </v-row>





      </v-container>


    </v-main>

  </v-app>
</template>

<script>
  import { startBarcodeScanner } from './utils/barcode';
  import setupKeyboardListeners from './utils/keyboardHandler';
  import barcodeHandler from './utils/barcodeHandler';
  import { mapActions, mapState } from "vuex";

  import Login from './Login.vue';
  import Screensaver from './Screensaver.vue';

  import DialogCashier from './Dialog/Cashier.vue';
  import DialogCheckPrice from './Dialog/CheckPrice.vue';
  import DialogSupply from './Dialog/Supply.vue';
  import DialogWithdrawal from './Dialog/Withdrawal.vue';
  import DialogSummary from './Dialog/Summary.vue';
  import DialogCalculator from './Dialog/Calculator.vue';
  import DialogCPF from './Dialog/CPF.vue';
  import DialogPreOrder from './Dialog/PreOrder.vue';

  import DialogOrder from './Dialog/Order.vue';
  import DialogConference from './Dialog/Conference.vue';
  import DialogPhone from './Dialog/Phone.vue';

  export default {
    components: {
      Screensaver,
      Login,
      DialogCashier,
      DialogCheckPrice,
      DialogSupply,
      DialogWithdrawal,
      DialogSummary,
      DialogCalculator,
      DialogCPF,
      DialogPreOrder,
      DialogOrder,
      DialogConference,
      DialogPhone


    },
    data() {
      return {
        lastEan: '',
        lastItem: {},
        lastOrder: {},
        paymentStone: {},
        received: {
          amount: 0,
        },

        preOrderData: null,
        payments: [],
        items: [],
        frozenItems: JSON.parse(localStorage.getItem('frozenSale') || '[]'),


        confirm: false,
        actionCallback: null,
        dialogChange: false,
        dialogFavorites: false,
        dialogProductError: false,
        dialogsearchProduct: false,
        dialogCheckPrice: false,
        dialogPayment: false,
        dialogCancelOrder: false,
        dialogSupply: false,
        dialogWithdrawal: false,
        dialogSummary: false,
        dialogCalculator: false,
        dialogCPF: false,
        preOrderDialog: false,
        dialogOrder: false,
        dialogMultiplier: false,
        dialogConference: false,
        dialogCashier: false,
        dialogPhone: false,

        processing: false,
        scanner: true,
        stonePay: true,

        barcode: "",

        amount: 0,
        multiplier: 1,
        chargeStoneId: null,

        selectedPOS: 'default',

        loadCheckPaymentStatus: false,
        isProcessingStonePayment: false

      };
    },

    methods: {

      ...mapActions("order", ["storeOrder"]),
      ...mapActions("customer", ["showByCard"]),
      ...mapActions("voucher", ["showVoucher", "storeVoucher"]),
      ...mapActions("auth", ["getUser", "logout"]),
      ...mapActions("exchange", ["storeExchange"]),
      ...mapActions("product", ["showFavoriteProducts"]),
      ...mapActions("paymentMethod", ["showPaymentMethods"]),
      ...mapActions("cashier", ["activeCashier", "closeCashier"]),
      ...mapActions("credit", ["storeCredit"]),
      ...mapActions("stocklosses", ["storeStockLoss"]),
      ...mapActions("print", [
        "printLabel",
        "printLastReceipt",
        "printContact"
      ]),


      simulateBarcodeInput(code) {
        const delay = 5;

        code.split('').forEach((char, index) => {
          setTimeout(() => {
            window.dispatchEvent(new KeyboardEvent('keydown', {
              key: char,
              bubbles: true
            }));
          }, index * delay);
        });

        setTimeout(() => {
          window.dispatchEvent(new KeyboardEvent('keydown', {
            key: 'Enter',
            bubbles: true
          }));
        }, code.length * delay);
      },


      requestSOS() {
        this.$toast.error('A funcionalidade SOS não está disponível no momento.');
      },

      restartPdv() {
        if (this.items.length === 0) {
          window.location.reload(true);
        } else {
          this.$toast.error('Não é possível reiniciar o PDV com itens no carrinho.')
        }
      },


      confirmMultiplier() {
        if (this.multiplier <= 0) {
          return
        }
        this.dialogMultiplier = false;
      },

      savePreOrder(data) {
        this.preOrderData = data
        this.preOrderDialog = false
      },


      printSelectedProductTags() {
        const productIds = this.items.map(item => item.product_id);

        if (!productIds.length) {
          this.$toast.error('Nenhum produto selecionado para imprimir');
          return;
        }

        this.printLabel(productIds).then(() => {
          this.$toast.success('Etiquetas enviadas para impressora com sucesso');
          this.items = []
        }).catch(() => {
          this.$toast.error('Erro ao imprimir etiquetas');
        });
      },

      printLastReceiptAction() {
        this.printLastReceipt();
      },
      printContactAction() {
        this.printContact();
      },

      freezeSale() {
        if (this.items.length === 0) {
          this.$toast.warning('Não há itens para congelar')
          return
        }
        const toFreeze = [...this.items]
        localStorage.setItem('frozenSale', JSON.stringify(toFreeze))
        this.items = []
        this.frozenItems = toFreeze
        this.$toast('Venda congelada com sucesso')
      },
      resumeSale() {
        if (!this.hasFrozenSale) {
          this.$toast.warning('Não há venda congelada para retomar')
          return
        }
        this.items = [...this.frozenItems]
        localStorage.removeItem('frozenSale')
        this.frozenItems = []
        this.$toast('Venda retomada com sucesso')
      },

      shut() {
        this.confirmAction(() => {
          const cash = JSON.parse(localStorage.getItem("dialogCloseCash") || "[]");
          const totalFromStorage = cash.reduce((prev, curr) => Number(prev) + Number(curr), 0).toFixed(2);

          if (totalFromStorage == '0.00') {
            this.$toast.error("Não há valores registrados na calculadora.");
            return;
          }

          this.closeCashier({
            id: this.cashier.id,
            final_cash: totalFromStorage,
          })
            .then(() => {
              localStorage.removeItem("dialogCloseAmount");
              localStorage.removeItem("dialogCloseCash");
              this.logout();
            })
            .catch((error) => {
              console.error("Erro ao encerrar o caixa:", error);
            });

        });

      },


      confirmAction(callback) {
        this.confirmCallback = callback;
        this.confirm = true;
      },

      confirmProceed() {
        this.confirm = false;
        if (typeof this.confirmCallback === 'function') {
          this.confirmCallback();
          this.confirmCallback = null;
        }
      },

      forceRegisterStone(){
        this.confirmAction(() => {
          this.finalizeStonePayment();
        });
      },

      confirmCancel() {
        this.confirmAction(() => {
          if (this.items.length === 0) {
            this.$toast.error("Não há itens para cancelar.");
            return;
          }
          this.dialogCancelOrder = false;
          this.payments = [];
          this.items = [];
          this.showByCard(1);
          this.$toast.info("Venda cancelada.");
        });
      },


      payWithMethod(id) {
        if (this.chargeStoneId) {
          this.$toast.error("Pagamento em andamento no POS Stone. Aguarde a finalização.");
          return;
        }
        if (this.canPay) {
          let payment = this.paymentMethods.find(p => p.id === id);

          if (payment) {
            this.received = {
              amount: this.received.amount == 0 ? this.receivable : this.received.amount,
              payment_method_id: payment.id,
              name: payment.name
            };
          }
          this.processPayment(this.received);
        }
        this.amount = ''
      },

      toggleStonePayment() { this.stonePay = !this.stonePay; },
      openPaymentDialog() { if (this.canPay) this.dialogPayment = true; },

      openSummaryDialog() {
        this.dialogSummary = true
      },

      openPreOrderDialog() {
        this.preOrderDialog = true
      },
      openDialogMultiplier() {
        this.dialogMultiplier = true
        this.multiplier = null
      },
      openSupplyDialog() {
        this.dialogSupply = true
      },
      openWithdrawalDialog() {
        this.dialogWithdrawal = true
      },

      openCalculatorDialog() {
        this.dialogCalculator = true
      },


      openCPFDialog() {
        this.showByCard(1);
        this.dialogCPF = true
      },

      openPhoneDialog() {
        this.showByCard(1);
        this.dialogPhone = true
      },


      openOrderDialog() {
        this.dialogOrder = true
      },

      openDialogConference() {
        this.dialogConference = true
      },

      openReceivePaymentDialog() {

      },

      openDrawer() {
        axios.get('/open-drawer')
          .then(response => {
            if (response.data.success) {
              this.$toast.success("Gaveta aberta com sucesso.");
            } else {
              this.$toast.error("Falha ao abrir a gaveta.");
            }
          })
          .catch(error => {
            console.error("Erro ao abrir a gaveta:", error);
            this.$toast.error("Erro ao abrir a gaveta.");
          });
      },

      openCheckPriceDialog() { this.dialogCheckPrice = true; },
      opensearchProductDialog() { this.dialogsearchProduct = true; },
      openFavoritesDialog() { this.$toast.error("Função desativada."); },

      togglePOS() {
        this.selectedPOS = this.selectedPOS === 'default' ? 'backup' : 'default';
      },

      removePayment() {
        this.$nextTick(() => {
          const selectedItem = this.$refs[`payment-0`];
          if (selectedItem && selectedItem[0]) selectedItem[0].$el.focus();
        });
      },
      removeProductFromCart() {
        this.$nextTick(() => {
          const selectedItem = this.$refs[`product-0`];
          if (selectedItem && selectedItem[0]) selectedItem[0].$el.focus();
        });
      },

      addProductToCart(product) {

        // const index = this.items.findIndex(item => item.product_id === product.product_id);

        // if (index !== -1) {
        //   const existingItem = this.items[index];
        //   existingItem.quantity += product.quantity;
        // } else {
        //   this.items.push({
        //     ...product,
        //   });
        // }

        this.items.push({
          ...product,
        });
      },

      removeProductFromCartList(index) {
        let id = this.items.length - 1 - index;

        this.items.splice(id, 1);

        this.$nextTick(() => {
          setTimeout(() => {
            document.activeElement.blur();
          }, 50);
        });
      },

      getProductQuantity(productId) {
        const item = this.items.find(item => item.product_id === productId);
        return item ? item.quantity : 0;
      },

      searchProduct(ean) {
        barcodeHandler(ean, this);
      },


      processPayment(data) {
        if (this.received == 0 || parseFloat(data.amount) === 0) {
          return;
        }
        if (this.received.payment_method_id !== 1 && this.received.payment_method_id !== 9 && this.received.amount > this.receivable) {
          this.$toast.error("Este meio de pagamento não permite receber um valor maior do que o valor pendente.");
          return;
        }
        data = JSON.parse(JSON.stringify(data));

        if (this.stonePay && ![1, 8, 9].includes(data.payment_method_id)) {
          this.processStonePaymentTransaction(data);
        } else {
          this.addPaymentToList(data);
        }

        this.dialogPayment = false;
        this.resetReceivedPayment();
        if (this.canRegister) {
          this.register();
        }
      },

      processStonePaymentTransaction(payment) {
        this.paymentStone = payment;

        if(this.chargeStoneId || this.isProcessingStonePayment){
          this.$toast.error("Já existe um pagamento em andamento no POS Stone.");
          return;
        }

        this.isProcessingStonePayment = true;

        axios.post('/api/stone', { payment: payment, pos: this.selectedPOS })
          .then(response => {
            if (response.data.id) {
              this.chargeStoneId = response.data.id;
            }
          })
          .catch(error => {
            this.removeChargeStone();
            if (error.response && error.response.data && error.response.data.error) {
              this.$toast.error(error.response.data.error);
            } else {
              this.$toast.error("Erro ao processar pagamento no POS Stone.");
            }
          }).finally(() => {
            this.isProcessingStonePayment = false;
          });
      },

      addPaymentToList(received) {
        if (received.amount > 0) {
          this.payments.push(received);
          this.resetReceivedPayment();
        }
      },

      removePaymentFromList(index) {

        this.payments.splice(index, 1);

        this.$nextTick(() => {
          setTimeout(() => {
            document.activeElement.blur();
          }, 1);
        });
      },

      resetReceivedPayment() {
        this.received = {
          amount: 0
        };
      },


      finalizeStonePayment(payment) {
        console.log("Finalizando pagamento no POS Stone:", payment);
        this.paymentStone.transaction = payment
        this.addPaymentToList(this.paymentStone);
        this.removeChargeStone();
        if (this.canRegister) {
          this.register();
        }
      },

      cancelStone() {
        if (this.chargeStoneId) {
          axios.post('/api/stone/cancelar', { id: this.chargeStoneId })
            .then(response => {
              if (response.data.status == 'canceled') {
                this.$toast.info("Pagamento no POS foi cancelado.");
                this.removeChargeStone();
                this.resetReceivedPayment();
              }
            })
            .catch(error => {
              console.log("Erro ao processar pagamento:", error);
            });
        }
      },

      checkPaymentStatus() {

        this.loadCheckPaymentStatus = true

        if (!this.chargeStoneId) {
          this.removeChargeStone();
          return;
        }

        axios.get(`/api/stone/${this.chargeStoneId}`)
          .then(response => {
            console.log("Status do pagamento:", response.data);
            if (response.data.status === 'paid') {
              this.finalizeStonePayment();
            } else if (response.data.status === 'canceled') {
              this.removeChargeStone();
            }
            this.$toast.info("Pagamento pendente.");
          })
          .catch(error => {
            this.$toast.error("Erro ao verificar status do pagamento.");
          }).finally(() => {
            this.loadCheckPaymentStatus = false;
          });
      },

      removeChargeStone() {
        this.chargeStoneId = null;
        this.paymentStone = {};
      },



      exchange() {
        this.processing = true;
        this.storeExchange({
          items: this.items,
          total: this.total,
        })
          .then((res) => {
            this.items = [];
          })
          .finally((res) => {
            this.processing = false;
          });
      },



      stockLoss() {
        this.confirmAction(() => {
          if (this.items.length === 0) {
            this.$toast.error("Não há itens para dar baixa.");
            return;
          }
          this.processing = true;
          this.storeStockLoss({
            items: this.items
          }).then((res) => {
            this.items = [];
          })
            .finally((res) => {
              this.processing = false;
            });
        });
      },



      register() {
        if (this.isReceivePaymentActive) {
          console.log("isReceivePaymentActive");
          this.storeCredit({
            customer: this.customer,
            payments: this.payments
          }).then((res) => {
            this.items = [];
            this.payments = [];
          }).finally(() => {
            this.showByCard(1);
          });
          return;
        }




        this.processing = true;

        const orderPayload = {
          items: this.items,
          received: this.totalReceived,
          payments: this.payments,
          change: this.change,
          total: this.total,
          customer_id: this.customer.id,
        };


        if (this.preOrderData) {
          orderPayload.preOrder = this.preOrderData;
        }

        this.storeOrder(orderPayload)
          .then((res) => {
            this.lastOrder = res.data;
            if (this.change) {
              this.showChange();
            }


          })
          .finally(() => {
            this.processing = false;

            this.items = [];
            this.payments = [];

            this.preOrderData = {}
          });



        this.showByCard(1);
      },



      pricing() {
        for (let i = 0; i < this.items.length; i++) {
          let unitPrice = this.items[i].original.price;

          if (this.items[i].quantity >= this.items[i].wholesale_quantity && this.items[i].wholesale_price > 0) {
            this.items[i].unit_price = this.items[i].wholesale_price;
          } else {
            this.items[i].unit_price = unitPrice;
          }
        }
      },

      cancellOrder() {
        this.payments = [];
        this.items = [];
        this.showByCard(1);
        this.$toast.error("Venda cancelada.");
      },

      showChange() {
        const change = Number(this.lastOrder && this.lastOrder.change) || 0;
        console.log(change)
        if (change <= 0) {
          this.$toast.error("Não há troco a ser exibido.");
          return;
        }
        this.dialogChange = true;
        setTimeout(() => {
          this.dialogChange = false;
        }, 3000);
      },

      showFavorites() {
        this.dialogFavorites = true;
        this.$nextTick(() => {
          this.$refs.myButton.$el.blur();
        });
      },

      LaunchAmount(amount) {
        this.received.amount = amount;
        this.dialogPayment = false;
      },
    },

    computed: {
      ...mapState("paymentMethod", ["paymentMethods"]),
      ...mapState("customer", ["customer", "customers"]),
      ...mapState("product", ["favorites"]),
      ...mapState("auth", ["user", "logged"]),
      ...mapState("cashier", ["cashier", "isOpenCashier"]),
      ...mapState("pos", ["pdv_id"]),


      isReceivePaymentActive() {
        return this.customer?.amount_owed > 0
          && this.items.length === 0;
      },

      hasFrozenSale() {
        return this.frozenItems.length > 0
      },

      total() {
        if (this.isReceivePaymentActive && this.customer.amount_owed > 0) {
          return this.customer.amount_owed;
        }
        return this.items.reduce(
          (total, { unit_price, quantity }) => total + Number(unit_price) * Number(quantity),
          0
        ).toFixed(2);
      },

      totalReceived() {
        return this.payments.reduce((total, { amount }) => total + Number(amount), 0).toFixed(2);
      },

      totalReceivedVoucher() {
        return this.payments
          .filter(({ payment_method_id }) => payment_method_id === 9)
          .reduce((total, { amount }) => total + Number(amount), 0)
          .toFixed(2);
      },

      receivable() {
        const receivable = this.total - this.totalReceived;
        return receivable > 0 ? parseFloat(receivable.toFixed(2)) : 0;
      },


      canRegister() {
        if (this.isReceivePaymentActive && Number(this.totalReceived) > 0) {
          return true;
        }
        return this.total > 0 && !this.processing && Number(this.totalReceived) >= Number(this.total);
      },

      canPay() {
        return this.receivable > 0;
      },

      change() {
        const change = parseFloat(this.totalReceived - this.totalReceivedVoucher - this.total);
        return change > 0 ? change.toFixed(2) : 0;
      },
    },

    watch: {
      items: {
        deep: true,
        handler() {
          this.pricing();
        },
      },

      confirm(newValue) {
        if (newValue) {
          this.dialogChange = false;
          this.dialogFavorites = false;
          this.dialogProductError = false;
          this.dialogsearchProduct = false;
          this.dialogCheckPrice = false;
          this.dialogPayment = false;
          this.dialogCancelOrder = false;
          this.dialogSupply = false;
          this.dialogWithdrawal = false;
          this.dialogSummary = false;
          this.dialogCalculator = false;
        }
      },

      // Persistência: observa todas as mudanças profundas no data
      $data: {
        handler(novoValor) {
          try {
            localStorage.setItem('pdvState', JSON.stringify(novoValor));
          } catch (e) {
            console.error('Erro ao salvar pdvState:', e);
          }
        },
        deep: true
      }
    },

    created() {

      // Restaura estado salvo antes de executar lógica original
      try {
        const salvo = localStorage.getItem('pdvState');
        if (salvo) {
          Object.assign(this.$data, JSON.parse(salvo));
        }
      } catch (e) {
        console.error('Erro ao restaurar pdvState:', e);
      }

      // ...existing code...
      this.getUser().then(() => {
        this.activeCashier();
        this.showPaymentMethods();
        this.showFavoriteProducts();
        this.showByCard(1).finally(() => {
          this.checkPaymentStatus();
        });
      })


    },

    mounted() {

      window.Echo.channel("my-channel").listen(".my-event", (event) => {
        console.log(event.data)
        const payment = event.data.data;
        if (event.data.type == 'charge.paid') {
          if (payment.order.id == this.chargeStoneId) {

            this.finalizeStonePayment(payment);
          }
        }
      });

      // Inicialização do leitor de código de barras
      startBarcodeScanner(this);

      // Configuração de listeners para o teclado
      setupKeyboardListeners(this);


    },
  };
</script>

<style>
  .text-field-transparent .v-input__slot {
    background: transparent !important;
  }
</style>
